import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionBtnComponent } from '@enginuity/core/molecules/action-btn/action-btn.component';
import { CounterComponent } from '@enginuity/core/molecules/counter/counter.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  imports: [CommonModule, ActionBtnComponent, CounterComponent, FormsModule],
})
export class PaginationComponent {
  @Output() onPageChange = new EventEmitter<number>();

  inputValue = '';
  inputWidth = 25;

  @ViewChild('hiddenSpan') hiddenSpan!: ElementRef<HTMLElement>;

  onInputChanged() {
    if (this.current.trim() === '') {
      this.inputWidth = 25;
    } else {
      const newWidth = this.current.length <= 2 ? 40 : (this.current.length + 1) * 8;
      if (newWidth > this.inputWidth) {
        this.inputWidth = newWidth;
      }
    }
  }

  @Input()
  state: 'default' | 'locked' = 'default';

  @Input()
  current: any = 1;

  @Input()
  total: number = 5;

  get previousActive() {
    if (this.current > 1) {
      return true;
    }
    return false;
  }

  get nextActive() {
    if (this.current < this.total && this.current !== 0) {
      return true;
    }
    return false;
  }

  isValidInput(value: any) {
    if (value <= this.total && value !== 0) {
      this.current = value;
      this.onPageChange.emit(this.current);
    } else {
      this.current = this.current;
    }
  }
}
